"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["value", "total", "label", "className", "clickable"];

var StatsWidgetNumber = function StatsWidgetNumber(props) {
  var value = props.value,
      total = props.total,
      label = props.label,
      className = props.className,
      clickable = props.clickable,
      remainingProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classes = (0, _classnames.default)('StatsWidgetNumber', clickable && 'cursor-pointer', className);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, remainingProps, {
    className: classes
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: 'StatsWidgetNumber-counter'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'StatsWidgetNumber-value'
  }, value), total && /*#__PURE__*/_react.default.createElement("div", {
    className: 'StatsWidgetNumber-total'
  }, total)), label && /*#__PURE__*/_react.default.createElement("div", {
    className: 'StatsWidgetNumber-label'
  }, label));
};

StatsWidgetNumber.defaultProps = {
  value: 0,
  clickable: false,
  onClick: function onClick() {}
};
StatsWidgetNumber.propTypes = {
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.node]).isRequired,
  total: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.node]),
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  clickable: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  className: _propTypes.default.string
};
var _default = StatsWidgetNumber;
exports.default = _default;